<script lang="ts" module>
  import type { TeoText } from '@/teoCore/text/TeoText';
  import BrandfitAssistant from '@/ui/brandfit/BrandfitAssistant.svelte';
  import { useActiveTextState } from '@/ui/state/use-text-state.svelte';

  import ColumnHeadline from '../../elements/column-headline/ColumnHeadline.svelte';
  import DictionaryAssistant from './Dictionary/DictionaryAssistant.svelte';
  import PerformanceComponent from './Performance/PerformanceComponent.svelte';
  import SpellCheckComponent from './SpellCheck/SpellCheckComponent.svelte';
  import StyleComponent from './Style/StyleComponent.svelte';
  import TextGeneratorView from './TextGenerator/TextGeneratorView.svelte';
  import VersionLogCard from './Versions/VersionLogCard.svelte';
</script>

<script lang="ts">
  const { teoText }: { teoText: TeoText } = $props();
  let TS = useActiveTextState();
  let view = $derived($TS.view);
</script>

{#if view !== 'new'}
  {#if view === 'performance'}
    <ColumnHeadline text="Performance-Pilot" />
    <PerformanceComponent {teoText}></PerformanceComponent>
  {:else if view === 'brand-scanner'}
    <ColumnHeadline text="Brand-Fit Assistent" />
    <BrandfitAssistant />
  {:else if view === 'style'}
    <ColumnHeadline text="Stil" />
    <StyleComponent {teoText}></StyleComponent>
  {:else if view === 'dictionary'}
    <ColumnHeadline text="Assistent" />
    <DictionaryAssistant />
  {:else if view === 'spellcheck'}
    <ColumnHeadline text="Rechtschreibung" />
    <SpellCheckComponent {teoText}></SpellCheckComponent>
  {:else if view === 'versions'}
    <ColumnHeadline text="Analyse Historie" />
    <VersionLogCard />
  {:else if view === 'text-generator'}
    <ColumnHeadline text="Text Generator" />
    <TextGeneratorView />
  {:else}
    <ColumnHeadline text="TODO" />
  {/if}
{/if}
